module.exports = __webpack_public_path__ + "img/us.bfaaeb1c.svg";